/**
 * LinkedAccountCard Component
 * Displays information about a linked sportsbook account
 */

import type { ReactElement } from 'react';
import { StatusBadge } from './StatusBadge';

interface LinkedAccountCardProps {
  sportsbook: string;
  sportsbookName: string;
  status: 'verified' | 'unverified' | 'inaccessible';
  linkedAt: string;
  lastRefreshAt: string | null;
}

export function LinkedAccountCard({
  sportsbookName,
  status,
  linkedAt,
  lastRefreshAt,
}: LinkedAccountCardProps): ReactElement {
  return (
    <div className="bg-theme-surface rounded-lg p-4 border border-theme-border">
      <div className="flex items-center justify-between mb-2">
        <h4 className="font-medium text-theme-text">{sportsbookName}</h4>
        <StatusBadge status={status} />
      </div>
      <div className="text-sm text-theme-text-secondary space-y-1">
        <p>Linked: {new Date(linkedAt).toLocaleDateString()}</p>
        {lastRefreshAt && <p>Last refresh: {new Date(lastRefreshAt).toLocaleString()}</p>}
      </div>
    </div>
  );
}
